import React, { useEffect, useRef, useState } from "react";
import * as R from "ramda";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import * as moment from "moment";
import { Printer } from "react-bootstrap-icons";
import { toDecimal } from "../../utils";
import { getCustomer } from "../bowlers/bowlers.redux";
import { openPhoto } from "../login/userSession.redux";
import { getPhotoForUserId } from "../../utils/utils";
import { Row, Col } from "react-bootstrap";
import logoSpectre from "../../images/spectre_logo_2022.png";
import backgroundFull from "../../images/BackgroundFull.png";
import backgroundThumbless from "../../images/BackgroundThumbless.png";
import { specsheetParser } from "../specsheet/specsheetParser";
import { renderPitchWithPolarity } from "../specsheet/pitchPolarity";
import {
  setLoadBalls,
  ballHandleForm,
  ballAddNew,
  ballRemove,
  ballSelect,
  ballSavePhoto,
  ballRemovePhoto,
  createJob,
} from "../arsenal/arsenal.redux";
import { divPrint } from "../bowlers/bowlers.redux";
import { api } from "../api/api";
import { ModalPdfPreview } from "../modal/ModalPdfPreview";

import styled, { createGlobalStyle } from "styled-components";

import "./styles.css";
import Spinner from "../ui/Spinner";

const imgPrinterStyle = {
  width: "30px",
  height: "22px",
};

const labelPrinterStyle = {
  marginTop: "3px",
};

const DivToPrintContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 8in !important;
  height: auto;
  padding: 0; /* Remove any padding */
  margin: 0; /* Remove any margin */
  // background-color: yellow;

  @media only screen and (max-width: 768px) {
    -webkit-text-size-adjust: none;
    text-size-adjust: none;
    transform: scale(0.5);
    margin-top: -2in;
  }

  @media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
    -webkit-text-size-adjust: none;
    text-size-adjust: none;
    transform: scaleX(0.85);
    margin-top: -2.475in;
  }
  @media print {
    width: 8.5in !important;
    padding: 0;
    margin: 0;
    transform: scale(0.8, 0.8);
    transform-origin: top left;
    margin-top: 0.5in;
    margin-left: 0.2in;
    .flex-container {
      display: block; /* Override flexbox for printing */
    }
  }
`;

const NoMarginRow = styled(Row)`
  @media print {
    margin: 0 !important;
  }
`;

export const PrintResets = createGlobalStyle`
  @media print {
    .ion-page {
      display: block !important;
      overflow: scroll !important;
    }
  }
`;

const DivToPrint = styled.div`
  width: 8in;
  // padding: 0.25in;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  /* General print styles */
  @media only print {
    margin: 0;
    box-shadow: none;
    border: none;
    position: relative; /* Use relative positioning for better alignment */
    top: 0;
    left: 0;
    width: 8.5in; /* Ensure content spans the full width of the printable area */
    align-items: flex-start; /* Align content at the top */
    overflow: scroll; /* Ensure no content is hidden */
    display: block !important;
    page-break-inside: auto;
    page-break-before: auto;
    page-break-after: auto;

    * {
      page-break-inside: avoid;
    }
  }
`;

const HeaderRow = styled(Row)`
  height: 1in;
  background-color: transparent;
  align-items: center;
  justify-content: left;
`;

const ImglogoProshop = {
  maxWidth: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const ProshopInfo = styled.div`
  color: #000000;
  font: normal normal 500 12px/14px Poppins;
  padding: 3px;
`;

const LineRow = styled(Row)`
  height: 0.8in;
  width: 100%;
  border-top: 1.5px solid #000000;
  border-left: none;
  border-right: none;
  justify-content: center;

  & .col {
    padding-left: 0;
    padding-right: 0;
  }
`;

const NameBowler = {
  color: "#000000",
  font: "normal normal 700 16px/18px Poppins",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
};

const BowlerInfoStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "0px",
};
const BowlerInfoTitle = {
  color: "#000000",
  font: "normal normal 700 14px/16px Poppins",
  textAlign: "center",
};

const BowlerInfo = {
  fontsize: "30px",
  color: "#000000",
  font: "normal normal 400 14px/16px Poppins",
  marginTop: "10px",
  textAlign: "center",
};

const TelephoneStyle = {
  fontsize: "14px",
};

const BarTitles = {
  height: "30px",
  backgroundColor: "black",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginLeft: "0px",
};
const TitleinBar = {
  color: "#FFFFFF",
  font: "normal normal 700 16px/18px Poppins",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const TitleImage = {
  color: "#000000",
  font: "normal normal 700 16px/18px Poppins",
  height: "30px",
  display: "flex",
  alignItems: "center",
  justifyContent: "left",
  marginLeft: "3px",
  width: "100%",
};

const ImageSpec = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  & .row {
    padding-left: 0;
    padding-right: 0;
    margin: 0;
  }
  @media print {
    & .row {
      margin-left: 22px;
      margin-right: 22px;
    }
  }
`;

const SpecsheetContainer = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "row",
  height: "95%",
  width: "100%",
};

const SpecsheetContainerPrint = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row; /* Ensure columns stay side-by-side */
  height: 95%; /* Maintain consistent height */
  width: 100%; /* Ensure it spans the full width */

  @media print {
    display: flex;
    flex-direction: row; /* Force side-by-side layout */
    align-items: center;
    justify-content: center;
    height: auto; /* Allow height to adjust dynamically */
    width: 100%; /* Ensure it spans the full width */
  }
`;

const BackgroundFullContainer = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 390,
  padding: 0,
};

const BackgroundFull = {
  backgroundImage: `url(${backgroundFull})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  width: 643 / 1.65,
  height: 762 / 1.65,
  position: "relative",
};

const BackgroundThumbless = {
  backgroundImage: `url(${backgroundThumbless})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  width: 643 / 1.65,
  height: 256 / 1.65,
  position: "relative",
};
const OValRoundStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: "330px",
};
const TitleSpecsContinued = {
  color: "#000000",
  font: "normal normal 700 14px/16px Poppins",
  marginTop: "5px",
  marginLeft: "10px",
};

const TitleThumbInfo = {
  color: "#00187E;",
  font: "normal normal 500 14px/16px Poppins",
  marginTop: "5px",
  marginLeft: "10px",
};

const SquareRoundButton = styled.div`
  width: 55px;
  height: 50px;
  border-radius: 10px 0px 0px 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.isOval ? "#dcdcdc" : "#00197b")};
  color: white;
`;
const SquareOvalButton = styled.div`
  width: 55px;
  height: 50px;
  border-radius: 0px 10px 10px 0px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.isOval ? "#00197b" : "#dcdcdc")};
  margin-left: 5px;
  color: white;
`;

const OValText = {
  color: "#ffffff",
  font: "normal normal 600 14px/16px Poppins",
};

const TitleHoleType = {
  color: "#00187E;",
  font: "normal normal 400 17px/18px Poppins",
  textAlign: "left",
  marginLeft: "5px",
  marginTop: "5px",
};

const Square = styled.div`
  width: 60px;
  height: 55px;
  border: 2px solid #dcdcdc;
  margin-top: 25px;
  margin-right: 8px;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const SquareTitle = {
  color: "#00147B",
  font: "normal normal 500 9px/12px Poppins",
  marginTop: "5px",
  textAlign: "center",
  padding: 0,
};

const SquareData = {
  color: "#00147B",
  font: "normal normal 700 18px/20px Poppins",
  marginTop: "5px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  textWrap: "nowrap",
};

const SquareVH = styled.div`
  width: 75px;
  height: 50px;
  border: 2px solid #dcdcdc;
  margin-top: 25px;
  margin-left: 5px;
  margin-right: 5px;
  border-radius: 10px 10px 10px 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  padding: 0;
`;

const NumberVH = {
  marginLeft: "15px",
  font: "normal normal 700 14px/16px Poppins",
};

const InfoVH = {
  color: "#000000",
  font: "normal normal 500 10px/12px Poppins",
  textAlign: "right",
};

const InfoVHTitle = {
  color: "#000000",
  font: "normal normal 500 10px/12px Poppins",
  textAlign: "left",
};

const InfoVHWrapper = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  padding: 2,
  paddingLeft: 2,
  paddingRight: 5,
};

const NameFieldListArsenal = {
  color: "#000000",
  font: "normal normal 700 12px/14px Poppins",
  textAlign: "center",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const FieldListArsenal = {
  color: "#000000",
  font: "normal normal 400 12px/14px Poppins",
  textAlign: "center",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
const LineRowArsenalList = styled(Row)`
  width: 100%;
  border: 1.5px solid #000000;
  border-left: none;
  border-right: none;

  & .row {
    padding-left: 0;
    padding-right: 0;
    margin: 0;
  }
`;

const styleLabelDiv = (top, left, width, height) => ({
  position: "absolute",
  top: `${top}px`,
  left: `${left}px`,
  width: `${width}px`,
  height: `${height}px`,
  backgroundColor: "transparent",
  textAlign: "center",
  fontSize: 13.5,
  fontWeight: `bolder`,
});

const UnSelectableTextFontFamily = "Poppins";

const styleTitleDiv = (top, left, width, height) => ({
  position: "absolute",
  top: `${top}px`,
  left: `${left}px`,
  width: `${width}px`,
  height: `${height}px`,
  backgroundColor: "transparent",
  textAlign: `center`,
  fontWeight: `900`,
  fontFamily: { UnSelectableTextFontFamily },
  fontSize: 7.5,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const styleTitleMiddle = (top, left, width, height) => ({
  position: "absolute",
  top: `${top}px`,
  left: `${left}px`,
  width: `${width}px`,
  height: `${height}px`,
  backgroundColor: "transparent",
  textAlign: `right`,
  fontWeight: `900`,
  fontFamily: { UnSelectableTextFontFamily },
  fontSize: 7.5,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
});

const SquareRowTitle = styled(Row)`
  flex: 1;
}`;

const SquareRowContent = styled(Row)`
  flex: 2;
}`;

const ButtonPrint = styled.button`
  border-radius: 4px;
  color: #00197b;
  font-size: 12px;
  font-weight: 600;
  background: transparent;
  border: 1px solid #00197b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 5px;
  min-width: 50px;
  height: 50px;
`;

const DivPage = styled.div`
  width: 100vw;
  max-width: 100%;
  max-width: 9in;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* Align content at the top */
  //overflow-y: scroll;
  align-items: center;
  //padding-bottom: 5vh;
  padding: 0;
  margin: 0;

  @media only print {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto; /* Allow height to adjust dynamically */
    //overflow: none;
    display: flex;
    flex-direction: column;
    justify-content: flex-start; /* Align content at the top */
    align-items: flex-start; /* Align content at the top */
    -webkit-print-color-adjust: exact;
  }
`;

const WhiteDiv = {
  backgroundColor: "#ffffff",
  width: 104,
  height: 30,
  position: "relative",
  top: 135,
  left: 144,
};

const DivHeader = styled.div`
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 20px;
  z-index: 9999;

  @media only print {
    display: none;
  }
`;

export const BallPrintRedux = (props) => {
  const {
    balls_drilled,
    currentLayout,
    specsheets,
    userId,
    getCustomer,
    loadingCustomer,
    ballHandleForm,
    ballAddNew,
    ballSelect,
    ballSavePhoto,
    ballRemovePhoto,
    ballRemove,
    currentBall,
    selectedCustomer,
    savingPhoto,
    is2Hander,
    havePap,
    isReadOnly,
    deviceInfo,
    pluginSubscriptions,
    createJob,
    currentJobs,
    plugin_settings,
    jobServices,
    openPhoto,
    currentBallSpecsheet,
    proshop,
    userInfo,
    isOval,
    isOvalWidthDifference,
    isOvalWidthDecimal,
    isOvalWidthStartingBit,
    divPrint,
    rightPlusMinus,
    leftPlusMinus,
    forwardPlusMinus,
    backPlusMinus,
    forwardPlusMinusFingers,
    backPlusMinusFingers,
    flip_vh,
    balls,
    selectedSpecsheet,
    appSettings,
    spanMeasurement,
  } = props;
  const printPageRef = useRef(null);
  const [showPdfPreview, setShowPdfPreview] = useState(false);

  const { t } = useTranslation();

  const params = useParams();
  const bowlerID = params.bowlerID;
  const ballID = params.ballID;
  const specsheetID = params.specsheetID;

  useEffect(() => {
    if (!selectedCustomer && !currentBall?.id) {
      getCustomer({
        customer_id: bowlerID,
        setCurrentball: ballID,
        setCurrentSpecsheet: specsheetID,
      });
    }
  }, [selectedCustomer, currentBall]);

  const getPhoto = getPhotoForUserId(userInfo?.id);
  const proshopLogo = getPhoto(proshop?.logo);

  const printingSpecsheet = specsheetParser(appSettings)(
    ballID ? currentBallSpecsheet : selectedSpecsheet || {}
  );

  const thm_oval_difference = isOvalWidthDifference
    ? printingSpecsheet &&
      printingSpecsheet.thm_oval_width &&
      printingSpecsheet.thm_oval_width !== "" &&
      printingSpecsheet.thm_oval_starting_bit &&
      printingSpecsheet.thm_oval_starting_bit !== ""
      ? (
          toDecimal(printingSpecsheet.thm_oval_width, spanMeasurement) -
          toDecimal(printingSpecsheet.thm_oval_starting_bit, spanMeasurement)
        ).toFixed(3)
      : printingSpecsheet &&
        printingSpecsheet.thm_oval_width &&
        printingSpecsheet.thm_oval_width !== "" &&
        (!printingSpecsheet.thm_oval_starting_bit ||
          printingSpecsheet.thm_oval_starting_bit === "")
      ? toDecimal(printingSpecsheet.thm_oval_width, spanMeasurement).toFixed(3)
      : "0.000"
    : printingSpecsheet
    ? toDecimal(printingSpecsheet.thm_oval_width, spanMeasurement).toFixed(3)
    : "0.000";

  const arsenal = ballID ? [currentBall] : balls || [];

  let f1_insertless = false;
  if (
    (printingSpecsheet?.f1_grip_type || "").toLowerCase() === "no inserts" ||
    printingSpecsheet?.f1_grip_type === ""
  ) {
    f1_insertless = true;
  }

  let f2_insertless = false;
  if (
    (printingSpecsheet?.f2_grip_type || "").toLowerCase() === "no inserts" ||
    printingSpecsheet?.f2_grip_type === ""
  ) {
    f2_insertless = true;
  }
  // useEffect(() => {
  //   const divToPrint = document.querySelector("#div-to-print");
  //   const pageHeight = 11 * 96; // 11 inches in pixels (assuming 96 DPI)
  //   if (divToPrint) {
  //     const contentHeight = divToPrint.offsetHeight; // Check if the device is mobile
  //     if (contentHeight > pageHeight) {
  //       const scaleFactor = (pageHeight * 0.9) / contentHeight; // Slightly reduce scale to ensure fit
  //       divToPrint.style.transform = `scaleY(${scaleFactor})`;
  //       divToPrint.style.transformOrigin = "top left";
  //       divToPrint.style.width = `100%`;
  //     }
  //   }
  // }, [arsenal]);

  function isChromeBrowser() {
    return (
      /Chrome/.test(navigator.userAgent) && !/Edg|OPR/.test(navigator.userAgent)
    );
  }

  const targetDiv = document.getElementById("div-container-print");

  function applyPrintStyles() {
    if (isChromeBrowser() && targetDiv) {
      targetDiv.style.transform = "scaleX(0.95)"; // or whatever scale you want
      targetDiv.style.transformOrigin = "top left"; // optional
    }
  }

  function removePrintStyles() {
    if (targetDiv) {
      targetDiv.style.transform = ""; // reset
    }
  }

  window.addEventListener("beforeprint", applyPrintStyles);
  window.addEventListener("afterprint", removePrintStyles);

  return loadingCustomer && balls_drilled.length === 0 ? (
    <Spinner />
  ) : (
    <DivPage>
      <PrintResets />
      <DivHeader>
        <ButtonPrint
          onClick={() => {
            // Server-rendered PDF via jsreport, shown inline in a modal
            // preview with Print / Download / Open-in-tab buttons.
            // Falls back to legacy window.print() if no specsheet is loaded.
            if (!printingSpecsheet?.id) {
              window.print();
              return;
            }
            setShowPdfPreview(true);
          }}
        >
          <Printer style={imgPrinterStyle} />
          <span style={labelPrinterStyle}>{t("Print")}</span>
        </ButtonPrint>
      </DivHeader>
      <DivToPrintContainer
        id="div-container-print"
        ref={printPageRef}
        className="flex-container"
      >
        <DivToPrint id="div-to-print">
          <HeaderRow>
            <Col
              xs="3"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={proshopLogo}
                style={ImglogoProshop}
                alt="Logo Proshop"
              />
            </Col>
            <Col xs="6">
              <ProshopInfo>{proshop?.name || ""}</ProshopInfo>
              <ProshopInfo>{proshop?.address || ""}</ProshopInfo>
              <ProshopInfo>{`${proshop?.city || ""}${
                proshop?.state ? "," : ""
              } ${proshop?.state || ""}${proshop?.postal_code ? "," : ""} ${
                proshop?.postal_code || ""
              }`}</ProshopInfo>
              <ProshopInfo>{userInfo?.phone || ""}</ProshopInfo>
              <ProshopInfo>{userInfo?.website || ""}</ProshopInfo>
            </Col>
            <Col xs="3">
              <img
                src={logoSpectre}
                style={ImglogoProshop}
                alt="Logo Spectre"
              />
            </Col>
          </HeaderRow>
          <LineRow>
            <Row style={BowlerInfoStyle}>
              <Col xs="3" style={NameBowler}>
                <Row>
                  <Col xs="12">
                    {`${selectedCustomer?.firstname?.toUpperCase() || ""} ${
                      selectedCustomer?.lastname?.toUpperCase() || ""
                    }`}
                  </Col>
                </Row>
                <Row>
                  <Col xs="12" style={TelephoneStyle}>
                    {`${selectedCustomer?.telephone?.toUpperCase() || ""}
                      `}
                  </Col>
                </Row>
              </Col>
              <Col xs="9">
                <Row style={BowlerInfoTitle}>
                  <Col>{t("form.label.pap")}</Col>
                  <Col>{t("form.label.axis_rotation")}</Col>
                  <Col>{t("form.label.tilt")}</Col>
                  <Col>{t("form.label.speed")}</Col>
                  <Col>Rev</Col>
                </Row>
                <Row style={BowlerInfo}>
                  <Col>
                    {selectedCustomer?.pap_h || ""} x{" "}
                    {selectedCustomer?.pap_v || ""}{" "}
                    {selectedCustomer?.pap_u_d ||
                      selectedCustomer?.pap_ud ||
                      ""}
                  </Col>
                  <Col>{selectedCustomer?.axis_rot || ""}</Col>
                  <Col>{selectedCustomer?.axis_tilt || ""}</Col>
                  <Col>{selectedCustomer?.ball_speed?.toUpperCase() || ""}</Col>
                  <Col>{selectedCustomer?.rev_rate?.toUpperCase() || ""}</Col>
                </Row>
              </Col>
            </Row>
          </LineRow>
          <ImageSpec>
            <Row style={BarTitles}>
              <Col xs="12" style={TitleinBar}>
                {t("spec_sheet")}
              </Col>
            </Row>
            <Row style={TitleImage}>
              <Col xs="6">
                {printingSpecsheet?.name}{" "}
                {moment(printingSpecsheet?.updated_at || "").format(
                  "MM/DD/YYYY"
                )}
              </Col>
              <Col xs="6" style={{ textAlign: "right", paddingRight: 20 }}>
                {t(printingSpecsheet?.hand)} / {t(printingSpecsheet?.ball_grip)}
              </Col>
            </Row>
            <Row style={SpecsheetContainer}>
              <Col xs="7" style={BackgroundFullContainer}>
                {!is2Hander && (
                  <div style={BackgroundFull}>
                    <div style={styleLabelDiv(18, 18, 46, 20)}>
                      {printingSpecsheet?.f1_rev &&
                      printingSpecsheet?.f1_rev !== "" &&
                      printingSpecsheet?.f1_rev !== "0.000" &&
                      printingSpecsheet?.f1_rev !== "0"
                        ? backPlusMinusFingers
                        : ""}
                      {printingSpecsheet?.f1_rev || ""}
                    </div>
                    <div style={styleTitleDiv(-3, 10, 60, 16)}>
                      {t("Reverse")}
                    </div>
                    <div style={styleLabelDiv(68, 18, 46, 20)}>
                      {renderPitchWithPolarity(
                        leftPlusMinus,
                        printingSpecsheet?.f1_lat
                      )}
                    </div>
                    <div style={styleTitleDiv(93, 10, 60, 16)}>{t("Left")}</div>
                    <div style={styleLabelDiv(118, 18, 46, 20)}>
                      {printingSpecsheet?.f1_for &&
                      printingSpecsheet?.f1_for !== "" &&
                      printingSpecsheet?.f1_for !== "0.000" &&
                      printingSpecsheet?.f1_for !== "0"
                        ? forwardPlusMinusFingers
                        : ""}
                      {printingSpecsheet?.f1_for || ""}
                    </div>
                    <div style={styleTitleDiv(143, 10, 60, 16)}>
                      {t("Forward")}
                    </div>
                    <div style={styleLabelDiv(50, 71, 96, 20)}>
                      {!f1_insertless && printingSpecsheet?.f1_od
                        ? printingSpecsheet?.f1_od
                        : printingSpecsheet?.f1_oval}
                    </div>
                    <div style={styleTitleDiv(64, 108, 20, 16)}>
                      {f1_insertless ? t("Oval") : t("O.D.")}
                    </div>
                    <div style={styleLabelDiv(84, 71, 96, 20)}>
                      {printingSpecsheet?.f1_size || ""}
                    </div>
                    <div style={styleTitleDiv(75, 90, 60, 16)}>
                      {t("Insert Size")}
                    </div>
                    <div style={styleLabelDiv(78, 173, 46, 20)}>
                      {printingSpecsheet?.bridge || ""}
                    </div>
                    <div style={styleTitleDiv(105, 168, 60, 16)}>
                      {t("Bridge")}
                    </div>
                    <div style={styleLabelDiv(35, 173, 46, 20)}>
                      {(printingSpecsheet?.vacu || "").toUpperCase()}
                    </div>
                    <div style={styleLabelDiv(50, 225, 96, 20)}>
                      {!f2_insertless && printingSpecsheet?.f2_od
                        ? printingSpecsheet?.f2_od
                        : printingSpecsheet?.f2_oval}
                    </div>
                    <div style={styleTitleDiv(64, 260, 20, 16)}>
                      {f2_insertless ? t("Oval") : t("O.D.")}
                    </div>
                    <div style={styleLabelDiv(83, 235, 76, 20)}>
                      {printingSpecsheet?.f2_size || ""}
                    </div>
                    <div style={styleTitleDiv(75, 240, 60, 16)}>
                      {t("Insert Size")}
                    </div>
                    <div style={styleLabelDiv(18, 328, 46, 20)}>
                      {printingSpecsheet?.f2_rev &&
                      printingSpecsheet?.f2_rev !== "" &&
                      printingSpecsheet?.f2_rev !== "0.000" &&
                      printingSpecsheet?.f2_rev !== "0"
                        ? backPlusMinusFingers
                        : ""}
                      {printingSpecsheet?.f2_rev || ""}
                    </div>
                    <div style={styleTitleDiv(-3, 320, 60, 16)}>
                      {t("Reverse")}
                    </div>
                    <div style={styleLabelDiv(68, 330, 46, 20)}>
                      {renderPitchWithPolarity(
                        rightPlusMinus,
                        printingSpecsheet?.f2_lat
                      )}
                    </div>
                    <div style={styleTitleDiv(93, 320, 60, 16)}>
                      {t("Right")}
                    </div>
                    <div style={styleLabelDiv(118, 330, 46, 20)}>
                      {printingSpecsheet?.f2_for &&
                      printingSpecsheet?.f2_for !== "" &&
                      printingSpecsheet?.f2_for !== "0.000" &&
                      printingSpecsheet?.f2_for !== "0"
                        ? forwardPlusMinusFingers
                        : ""}
                      {printingSpecsheet?.f2_for || ""}
                    </div>
                    <div style={styleTitleDiv(143, 320, 60, 16)}>
                      {t("Forward")}
                    </div>
                    <div style={styleTitleMiddle(152, 24, 60, 16)}>
                      {" "}
                      {t("Middle finger Full")}
                    </div>
                    <div style={styleLabelDiv(150, 94, 74, 20)}>
                      {printingSpecsheet?.f1_span_full || ""}
                    </div>
                    <div style={styleTitleMiddle(180, 24, 60, 16)}>
                      {t("Middle finger Cut")}
                    </div>
                    <div style={styleLabelDiv(178, 94, 74, 20)}>
                      {printingSpecsheet?.f1_span_cut || ""}
                    </div>
                    <div style={styleTitleMiddle(208, 24, 60, 16)}>
                      {t("Middle finger Outer to Cut")}
                    </div>
                    <div style={styleLabelDiv(205, 94, 74, 20)}>
                      {printingSpecsheet?.f1_span_outer2_cut || ""}
                    </div>
                    <div style={styleTitleMiddle(235, 24, 60, 16)}>
                      {t("Middle finger Hole to Hole")}
                    </div>
                    <div style={styleLabelDiv(232, 94, 74, 20)}>
                      {printingSpecsheet?.f1_span_hole_to_hole || ""}
                    </div>
                    <div style={styleLabelDiv(150, 224, 74, 20)}>
                      {printingSpecsheet?.f2_span_full || ""}
                    </div>
                    <div style={styleLabelDiv(178, 224, 74, 20)}>
                      {printingSpecsheet?.f2_span_cut || ""}
                    </div>
                    <div style={styleLabelDiv(206, 224, 74, 20)}>
                      {printingSpecsheet?.f2_span_outer2_cut || ""}
                    </div>
                    <div style={styleLabelDiv(232, 224, 74, 20)}>
                      {printingSpecsheet?.f2_span_hole_to_hole || ""}
                    </div>

                    <div style={styleLabelDiv(282, 173, 46, 20)}>
                      {printingSpecsheet?.thm_for &&
                      printingSpecsheet?.thm_for !== "" &&
                      printingSpecsheet?.thm_for !== "0.000" &&
                      printingSpecsheet?.thm_for !== "0"
                        ? forwardPlusMinus
                        : ""}
                      {printingSpecsheet?.thm_for || ""}
                    </div>
                    <div style={styleTitleDiv(308, 168, 60, 16)}>
                      {t("Forward")}
                    </div>
                    <div style={styleLabelDiv(335, 173, 46, 20)}>
                      {printingSpecsheet?.thm_od || ""}
                    </div>
                    <div style={styleTitleDiv(351, 166, 60, 16)}>
                      {t("O.D.")}
                    </div>
                    <div style={styleLabelDiv(373, 173, 46, 20)}>
                      {isOval
                        ? printingSpecsheet?.thm_oval_starting_bit
                        : printingSpecsheet?.thm_size}
                    </div>
                    <div style={styleTitleDiv(361, 156, 80, 16)}>
                      {t("Hole Size")}
                    </div>
                    <div style={styleLabelDiv(422, 173, 46, 20)}>
                      {printingSpecsheet?.thm_rev &&
                      printingSpecsheet?.thm_rev !== "" &&
                      printingSpecsheet?.thm_rev !== "0.000" &&
                      printingSpecsheet?.thm_rev !== "0"
                        ? backPlusMinus
                        : ""}
                      {printingSpecsheet?.thm_rev || ""}
                    </div>
                    <div style={styleTitleDiv(402, 156, 80, 16)}>
                      {t("Reverse")}
                    </div>
                    <div style={styleLabelDiv(353, 94, 46, 20)}>
                      {renderPitchWithPolarity(
                        leftPlusMinus,
                        printingSpecsheet?.thm_lat_l
                      )}
                    </div>
                    <div style={styleTitleDiv(379, 88, 60, 16)}>
                      {" "}
                      {t("Left")}
                    </div>

                    <div style={styleLabelDiv(353, 252, 46, 20)}>
                      {renderPitchWithPolarity(
                        rightPlusMinus,
                        printingSpecsheet?.thm_lat_r
                      )}
                    </div>
                    <div style={styleTitleDiv(379, 246, 60, 16)}>
                      {t("Right")}
                    </div>
                    <div style={styleTitleDiv(4, 74, 90, 20)}>
                      {printingSpecsheet?.f1_grip_type || ""}
                    </div>
                    <div style={styleTitleDiv(19, 74, 90, 16)}>
                      {t("Inserts")}
                    </div>
                    <div style={styleTitleDiv(4, 225, 90, 20)}>
                      {printingSpecsheet?.f2_grip_type || ""}
                    </div>
                    <div style={styleTitleDiv(19, 225, 90, 16)}>
                      {t("Inserts")}
                    </div>

                    <div style={styleLabelDiv(270, 58, 46, 20)}>
                      {printingSpecsheet?.thm_flex || ""}
                    </div>
                    <div style={styleTitleDiv(260, 50, 60, 16)}>
                      {t("Flexibility")}
                    </div>
                    <div style={styleTitleDiv(274, 256, 110, 20)}>
                      {printingSpecsheet?.thm_insert_type || ""}
                    </div>
                    <div style={styleTitleDiv(264, 270, 80, 16)}>
                      {t("Thumb Insert Type")}
                    </div>
                    <div style={styleLabelDiv(412, 57, 46, 20)}>
                      {printingSpecsheet?.thm_offset || ""}
                    </div>
                    <div style={styleTitleDiv(402, 50, 60, 16)}>
                      {t("Offset")}
                    </div>

                    <div style={styleLabelDiv(411, 290, 46, 20)}>
                      {printingSpecsheet?.clt || ""}
                    </div>
                    <div style={styleTitleDiv(402, 280, 60, 16)}>
                      {t("CLT")}
                    </div>
                  </div>
                )}
                {is2Hander && (
                  <div style={BackgroundThumbless}>
                    <div style={styleLabelDiv(18, 18, 46, 20)}>
                      {printingSpecsheet?.f1_rev &&
                      printingSpecsheet?.f1_rev !== "" &&
                      printingSpecsheet?.f1_rev !== "0.000" &&
                      printingSpecsheet?.f1_rev !== "0"
                        ? backPlusMinusFingers
                        : ""}
                      {printingSpecsheet?.f1_rev || ""}
                    </div>
                    <div style={styleTitleDiv(-3, 10, 60, 16)}>
                      {t("Reverse")}
                    </div>
                    <div style={styleLabelDiv(68, 18, 46, 20)}>
                      {renderPitchWithPolarity(
                        leftPlusMinus,
                        printingSpecsheet?.f1_lat
                      )}
                    </div>
                    <div style={styleTitleDiv(93, 10, 60, 16)}>{t("Left")}</div>
                    <div style={styleLabelDiv(118, 18, 46, 20)}>
                      {printingSpecsheet?.f1_for &&
                      printingSpecsheet?.f1_for !== "" &&
                      printingSpecsheet?.f1_for !== "0.000" &&
                      printingSpecsheet?.f1_for !== "0"
                        ? forwardPlusMinusFingers
                        : ""}
                      {printingSpecsheet?.f1_for || ""}
                    </div>
                    <div style={styleTitleDiv(143, 10, 60, 16)}>
                      {t("Forward")}
                    </div>
                    <div style={styleLabelDiv(50, 71, 96, 20)}>
                      {!f1_insertless && printingSpecsheet?.f1_od
                        ? printingSpecsheet?.f1_od
                        : printingSpecsheet?.f1_oval}
                    </div>
                    <div style={styleTitleDiv(64, 108, 20, 16)}>
                      {f1_insertless ? t("Oval") : t("O.D.")}
                    </div>
                    <div style={styleLabelDiv(84, 71, 96, 20)}>
                      {printingSpecsheet?.f1_size || ""}
                    </div>
                    <div style={styleTitleDiv(75, 90, 60, 16)}>
                      {t("Insert Size")}
                    </div>
                    <div style={styleLabelDiv(78, 173, 46, 20)}>
                      {printingSpecsheet?.bridge || ""}
                    </div>
                    <div style={styleTitleDiv(105, 168, 60, 16)}>
                      {t("Bridge")}
                    </div>
                    <div style={styleLabelDiv(35, 173, 46, 20)}>
                      {(printingSpecsheet?.vacu || "").toUpperCase()}
                    </div>
                    <div style={styleLabelDiv(51, 225, 96, 20)}>
                      {!f2_insertless && printingSpecsheet?.f2_od
                        ? printingSpecsheet?.f2_od
                        : printingSpecsheet?.f2_oval}
                    </div>
                    <div style={styleTitleDiv(64, 260, 20, 16)}>
                      {f2_insertless ? t("Oval") : t("O.D.")}
                    </div>
                    <div style={styleLabelDiv(83, 225, 96, 20)}>
                      {printingSpecsheet?.f2_size || ""}
                    </div>
                    <div style={styleTitleDiv(75, 240, 60, 16)}>
                      {t("Insert Size")}
                    </div>
                    <div style={styleLabelDiv(18, 328, 46, 20)}>
                      {printingSpecsheet?.f2_rev &&
                      printingSpecsheet?.f2_rev !== "" &&
                      printingSpecsheet?.f2_rev !== "0.000" &&
                      printingSpecsheet?.f2_rev !== "0"
                        ? backPlusMinusFingers
                        : ""}
                      {printingSpecsheet?.f2_rev || ""}
                    </div>
                    <div style={styleTitleDiv(-3, 320, 60, 16)}>
                      {t("Reverse")}
                    </div>
                    <div style={styleLabelDiv(68, 330, 46, 20)}>
                      {renderPitchWithPolarity(
                        rightPlusMinus,
                        printingSpecsheet?.f2_lat
                      )}
                    </div>
                    <div style={styleTitleDiv(93, 320, 60, 16)}>
                      {t("Right")}
                    </div>
                    <div style={styleLabelDiv(118, 330, 46, 20)}>
                      {printingSpecsheet?.f2_for &&
                      printingSpecsheet?.f2_for !== "" &&
                      printingSpecsheet?.f2_for !== "0.000" &&
                      printingSpecsheet?.f2_for !== "0"
                        ? forwardPlusMinusFingers
                        : ""}
                      {printingSpecsheet?.f2_for || ""}
                    </div>
                    <div style={styleTitleDiv(143, 320, 60, 16)}>
                      {t("Forward")}
                    </div>
                    <div style={WhiteDiv}></div>

                    <div style={styleTitleDiv(4, 84, 70, 20)}>
                      {printingSpecsheet?.f1_grip_type || ""}
                    </div>
                    <div style={styleTitleDiv(19, 87, 60, 16)}>
                      {t("Inserts")}
                    </div>
                    <div style={styleTitleDiv(4, 236, 70, 20)}>
                      {printingSpecsheet?.f2_grip_type || ""}
                    </div>
                    <div style={styleTitleDiv(19, 239, 60, 16)}>
                      {t("Inserts")}
                    </div>
                    <div style={styleLabelDiv(36, 173, 46, 20)}></div>
                  </div>
                )}
              </Col>
              {!is2Hander && (
                <Col xs="5">
                  <Row style={OValRoundStyle}>
                    <Col xs="5">
                      <Row>
                        <Col style={TitleSpecsContinued}>
                          {t("form.label.specs_continued")}
                        </Col>
                      </Row>
                      <Row>
                        <Col style={TitleThumbInfo}>
                          {t("form.label.thumb_info")}
                        </Col>
                      </Row>
                    </Col>
                    <Col xs="7">
                      {/* <SquareRoundButton isOval={isOval}>
                        <div style={OValText}> {t("round")}</div>
                      </SquareRoundButton>
                      <SquareOvalButton isOval={isOval}>
                        <div style={OValText}>{t("oval")}</div>
                      </SquareOvalButton> */}
                      <Row>
                        <Col style={TitleHoleType}>
                          {t("hole_type")}: {t(isOval ? "oval" : "round")}
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  {!isOval && (
                    <Row
                      style={{ justifyContent: "center", alignItems: "center" }}
                    >
                      <Square xs="3">
                        <SquareRowTitle>
                          <Col style={SquareTitle}>{t("form.label.size")}</Col>
                        </SquareRowTitle>
                        <SquareRowContent>
                          <Col style={SquareData}>
                            {printingSpecsheet?.thm_size || ""}
                          </Col>
                        </SquareRowContent>
                      </Square>
                      <Square xs="3">
                        <SquareRowTitle>
                          <Col style={SquareTitle}>
                            {t("form.label.insert_OD")}
                          </Col>
                        </SquareRowTitle>
                        <SquareRowContent>
                          <Col style={SquareData}>
                            {printingSpecsheet?.thm_od || ""}
                          </Col>
                        </SquareRowContent>
                      </Square>
                      <Square xs="3">
                        <SquareRowTitle>
                          <Col style={SquareTitle}>
                            {t("form.label.taper_size")}
                          </Col>
                        </SquareRowTitle>
                        <SquareRowContent>
                          <Col style={SquareData}>
                            {printingSpecsheet?.thm_round_taper || ""}
                          </Col>
                        </SquareRowContent>
                      </Square>
                    </Row>
                  )}

                  {isOval && (
                    <Row>
                      <Square xs="3">
                        <SquareRowTitle>
                          <Col style={SquareTitle}>
                            {t("form.label.starting_bit")}
                          </Col>
                        </SquareRowTitle>
                        <SquareRowContent>
                          <Col style={SquareData}>
                            {printingSpecsheet?.thm_oval_starting_bit || ""}
                          </Col>
                        </SquareRowContent>
                      </Square>
                      <Square xs="3">
                        <SquareRowTitle>
                          <Col style={SquareTitle}>
                            {isOvalWidthDifference
                              ? t("form.label.oval_difference")
                              : t("form.label.oval_width")}
                          </Col>
                        </SquareRowTitle>
                        <SquareRowContent>
                          <Col style={SquareData}>
                            {isOvalWidthDifference || isOvalWidthDecimal
                              ? thm_oval_difference || ""
                              : printingSpecsheet?.thm_oval_width || ""}
                          </Col>
                        </SquareRowContent>
                      </Square>
                      <Square xs="3">
                        <SquareRowTitle>
                          <Col style={SquareTitle}>
                            {t("form.label.oval_degree")}
                          </Col>
                        </SquareRowTitle>
                        <SquareRowContent>
                          <Col style={SquareData}>
                            {printingSpecsheet?.thm_oval_degree || ""}
                          </Col>
                        </SquareRowContent>
                      </Square>
                      <Square xs="3">
                        <SquareRowTitle>
                          <Col style={SquareTitle}>{t("form.label.taper")}</Col>
                        </SquareRowTitle>
                        <SquareRowContent>
                          <Col style={SquareData}>
                            {printingSpecsheet?.thm_oval_taper || ""}
                          </Col>
                        </SquareRowContent>
                      </Square>
                    </Row>
                  )}

                  {isOval && (
                    <Row>
                      {(printingSpecsheet?.thumb_cuts || [])
                        .sort((t1, t2) =>
                          t1.cut_number * 1 <= t2.cut_number * 1 ? -1 : 1
                        )
                        .map((cut, index) => (
                          <SquareVH>
                            <div style={{ flex: 1 }}>
                              <span
                                style={NumberVH}
                                dangerouslySetInnerHTML={{
                                  __html: cut.label,
                                }}
                              />
                            </div>
                            <div
                              style={{
                                flex: 2,
                                width: "70px",
                                textAlign: "center",
                              }}
                            >
                              <NoMarginRow>
                                <Col style={{ textAlign: "center" }}>
                                  {!flip_vh && (
                                    <div style={InfoVHWrapper}>
                                      <span style={InfoVHTitle}>V:</span>
                                      <span style={InfoVH}>
                                        {(cut.v * 1).toFixed(3)}
                                      </span>
                                    </div>
                                  )}
                                  {flip_vh && (
                                    <div style={InfoVHWrapper}>
                                      <span style={InfoVHTitle}>H:</span>
                                      <span style={InfoVH}>
                                        {(cut.h * 1).toFixed(3)}
                                      </span>
                                    </div>
                                  )}
                                </Col>
                              </NoMarginRow>
                              <NoMarginRow>
                                <Col style={{ textAlign: "center" }}>
                                  {!flip_vh && (
                                    <div style={InfoVHWrapper}>
                                      <span style={InfoVHTitle}>H:</span>
                                      <span style={InfoVH}>
                                        {(cut.h * 1).toFixed(3)}
                                      </span>
                                    </div>
                                  )}
                                  {flip_vh && (
                                    <div style={InfoVHWrapper}>
                                      <span style={InfoVHTitle}>V:</span>
                                      <span style={InfoVH}>
                                        {(cut.v * 1).toFixed(3)}
                                      </span>
                                    </div>
                                  )}
                                </Col>
                              </NoMarginRow>
                            </div>
                          </SquareVH>
                        ))}
                    </Row>
                  )}
                </Col>
              )}
            </Row>
          </ImageSpec>
          <LineRowArsenalList
            id="line-row-arsenal-list"
            style={{ marginTop: 20 }}
          >
            <Row style={BarTitles}>
              <Col xs="12" style={TitleinBar}>
                {t("form.label.notes")}
              </Col>
            </Row>
            <Row>
              <Col xs="12" style={{ marginTop: 10 }}>
                <span
                  dangerouslySetInnerHTML={{
                    __html: printingSpecsheet?.note || "",
                  }}
                />
              </Col>
            </Row>
            <Row style={BarTitles}>
              <Col xs="12" style={TitleinBar}>
                {t("form.label.arsenal")}
              </Col>
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col xs="2" style={NameFieldListArsenal}>
                {t("Date drilled")}
              </Col>
              <Col xs="2" style={NameFieldListArsenal}>
                {t("form.placeholder.ball_name")}
              </Col>
              <Col xs="2" style={NameFieldListArsenal}>
                {t("Weight")}
              </Col>
              <Col xs="2" style={NameFieldListArsenal}>
                {t("form.placeholder.serial_number")}
              </Col>
              <Col xs="2" style={NameFieldListArsenal}>
                {t("Layout")}
              </Col>
              <Col xs="2" style={NameFieldListArsenal}>
                {t("form.label.notes")}
              </Col>
            </Row>
          </LineRowArsenalList>

          {arsenal
            .filter((ball) => ball?.enable === true)
            .map((currentBall) => (
              <Row
                style={{
                  width: "100%",
                  marginTop: 6,
                  pageBreakAfter: "always",
                  breakAfter: "always",
                }}
              >
                <Col xs="2" style={FieldListArsenal}>
                  {moment(currentBall?.date_drilled || "").format("MM/DD/YYYY")}
                </Col>
                <Col xs="2" style={FieldListArsenal}>
                  {currentBall?.ball_name || ""}
                </Col>
                <Col xs="2" style={FieldListArsenal}>
                  {currentBall?.weight || ""}
                </Col>
                <Col xs="2" style={FieldListArsenal}>
                  {currentBall?.serial_number || ""}
                </Col>
                <Col xs="2" style={FieldListArsenal}>
                  {currentBall?.layout || ""}
                </Col>
                <Col xs="2" style={FieldListArsenal}>
                  {(currentBall?.note || "").replace(/(<([^>]+)>)/gi, "")
                    .length < 100
                    ? (currentBall?.note || "").replace(/(<([^>]+)>)/gi, "")
                    : `${(currentBall?.note || "")
                        .replace(/(<([^>]+)>)/gi, "")
                        .slice(100)}...`}
                </Col>
                <div class="page-break"></div>
              </Row>
            ))}
        </DivToPrint>
      </DivToPrintContainer>
      <ModalPdfPreview
        show={showPdfPreview}
        onHide={() => setShowPdfPreview(false)}
        pdfPath={
          printingSpecsheet?.id
            ? `render/specsheet/${bowlerID}/${printingSpecsheet.id}`
            : null
        }
        // If we arrived via /print/:bowlerID/ball/:ballID the print is scoped
        // to that single ball — pass it as a param so the arsenal table shows
        // only that ball, not the whole customer arsenal.
        pdfParams={ballID ? { ballId: ballID } : undefined}
        fileName={
          selectedCustomer
            ? `specsheet-${selectedCustomer.lastname || ""}-${
                selectedCustomer.firstname || ""
              }`
            : "specsheet"
        }
      />
    </DivPage>
  );
};

export const BallPrint = connect(
  (state) => {
    const specsheets = state.bowlers.selectedCustomer?.specsheets || [];
    const printingSpecsheet =
      specsheets.find(
        (specsheet) =>
          specsheet.id ===
          (state.balls.currentBall?.spec_sheet?.id ||
            state.balls.currentBall?.specsheet_id)
      ) || state.specsheet.currentSpecSheet;
    const appSettings = state.settings.appSettings;
    const printingSpecsheetParsed =
      specsheetParser(appSettings)(printingSpecsheet);
    const isOval = R.path(["thm_type"])(printingSpecsheetParsed) === "Oval";

    const rightPlusMinus = appSettings.drillPressCalibration
      ?.oval_machine_show_pitch_plus_minus
      ? appSettings.drillPressCalibration?.oval_machine_right_positive
        ? "+"
        : "-"
      : "";
    const leftPlusMinus = appSettings.drillPressCalibration
      ?.oval_machine_show_pitch_plus_minus
      ? appSettings.drillPressCalibration?.oval_machine_right_positive
        ? "-"
        : "+"
      : "";

    const forwardPlusMinus = appSettings.drillPressCalibration
      ?.oval_machine_show_pitch_plus_minus
      ? appSettings.drillPressCalibration?.oval_machine_forward_thumb_positive
        ? "+"
        : "-"
      : "";
    const backPlusMinus = appSettings.drillPressCalibration
      ?.oval_machine_show_pitch_plus_minus
      ? appSettings.drillPressCalibration?.oval_machine_forward_thumb_positive
        ? "-"
        : "+"
      : "";

    const forwardPlusMinusFingers = appSettings.drillPressCalibration
      ?.oval_machine_show_pitch_plus_minus
      ? appSettings.drillPressCalibration?.oval_machine_forward_thumb_positive
        ? "-"
        : "+"
      : "";
    const backPlusMinusFingers = appSettings.drillPressCalibration
      ?.oval_machine_show_pitch_plus_minus
      ? appSettings.drillPressCalibration?.oval_machine_forward_thumb_positive
        ? "+"
        : "-"
      : "";

    return {
      rightPlusMinus,
      leftPlusMinus,
      forwardPlusMinus,
      backPlusMinus,
      forwardPlusMinusFingers,
      backPlusMinusFingers,
      loadingCustomer: state.bowlers.loadingCustomer,
      deviceInfo: state.userSession.deviceInfo,
      selectedCustomer: state.bowlers.selectedCustomer,
      currentBall: state.balls.currentBall,
      arsenal_layout_style:
        state.settings.appSettings.layoutPreferences.arsenal_layout_style,
      spanMeasurement:
        state.settings.appSettings.systemDefault.span_measurement,
      loadingBalls: state.balls.loading,
      balls_drilled: state.bowlers.selectedCustomer?.balls_drilled || [],
      specsheets: state.bowlers.selectedCustomer?.specsheets || [],
      currentBallSpecsheet: printingSpecsheet,
      currentLayout:
        state.settings.appSettings.layoutPreferences.arsenal_layout_style,
      state: state,
      userId: state.userSession.userData.id,
      savingPhoto: state.balls.savingPhoto,
      isReadOnly: state.userSession.isReadOnly,
      is2Hander:
        state.bowlers.selectedCustomer?.style === "two_handed" ||
        state.bowlers.selectedCustomer?.style === "thumbless",
      havePap:
        (state.bowlers.selectedCustomer?.pap_h &&
          state.bowlers.selectedCustomer?.pap_h !== "") ||
        (state.bowlers.selectedCustomer?.pap_v &&
          state.bowlers.selectedCustomer?.pap_v !== "") ||
        (state.bowlers.selectedCustomer?.pap_u_d &&
          state.bowlers.selectedCustomer?.pap_u_d !== "") ||
        (state.bowlers.selectedCustomer?.pap_ud &&
          state.bowlers.selectedCustomer?.pap_ud !== ""),
      pluginSubscriptions: state.plugin.pluginSubscriptions,
      currentJobs: state.balls.currentJobs,
      plugin_settings: state.plugin.plugin_settings,
      jobServices: state.plugin.jobServices,
      proshop: state.userSession.proshop,
      userInfo: state.userSession.userData,
      isOval,
      isOvalWidthDifference:
        isOval &&
        state.settings.appSettings.thumbHolePreferences
          .oval_width_difference === "0",
      isOvalWidthDecimal:
        isOval &&
        state.settings.appSettings.thumbHolePreferences
          .oval_width_difference === "decimal",
      isOvalWidthStartingBit:
        isOval &&
        state.settings.appSettings.thumbHolePreferences
          .oval_width_difference === "64th",
      flip_vh: state.settings.appSettings.thumbHolePreferences.flip_vh !== "vh",
      selectedSpecsheet: state.specsheet.currentSpecSheet,
      balls: state.bowlers.selectedCustomer?.balls_drilled,
      appSettings,
    };
  },
  {
    getCustomer,
    setLoadBalls,
    ballHandleForm,
    ballAddNew,
    ballSelect,
    ballSavePhoto,
    ballRemovePhoto,
    ballRemove,
    createJob,
    openPhoto,
    divPrint,
  }
)(BallPrintRedux);
